import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import MarketplaceLogo from "../../../assets/HomePage/MarketplaceLogo.svg";
import BackIcon from "../../../assets/Header/backIcon.svg";
import Button from "../../../common/Button";
import {
  useAttachMarketPlaces,
  useGetAllMarketPlace,
} from "../../../hooks/useOrderBatches";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { message } from "antd";
import { SignInApi } from "../../../apis/SignIn";
import { BatchMarketPlaceContext } from "../../../context/batchProvider";
import Stepper from "../../Stepper";
const SelectMarketplace = () => {
  const [marketPlaceList, setMarketPlaceList] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const params = useParams();
  const {
    batch_selectedMarketPlaces,
    batch_setSelectedMarketPlaces,
    batch_skipPages,
  } = useContext(BatchMarketPlaceContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [isDefault, setIsDefault] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const userResponse = await SignInApi.getSource("");
        if (userResponse.status === 200) {
          if (userResponse?.data?.allowedMarketplaces?.length > 0) {
            setIsDefault(false);
          } else {
            setIsDefault(true);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, []);

  const onSuccessGetAllMarketPlace = (res) => {
    if (res.status === 200) {
      setMarketPlaceList(res?.data?.data);
      if (res.data.data.length === 1) {
        const item = res.data.data[0];
        batch_setSelectedMarketPlaces((prevSelected) => {
          const isAlreadySelected = prevSelected?.some(
            (selected) => selected.id === item._id
          );
          const updatedSelected =
            // isAlreadySelected
            // ? prevSelected.filter((selected) => selected.id !== item._id)
            // :
            [{ id: item?._id, name: item?.name }];

          const selectedIds = updatedSelected.map((value) => value?.id);
          let payload = {
            batchId: params.batchId,
            marketplaces: selectedIds,
          };
          attachMarketPlace(payload);
          return updatedSelected;
        });
      }
    }
  };

  const onErrorGetAllMarketPlace = (err) => {
    console.log(err.message);
  };
  const { data: getAllMarketPlace } = useGetAllMarketPlace(
    "getAllMarketPlace",
    null,
    pageNum,
    pageSize,
    onSuccessGetAllMarketPlace,
    onErrorGetAllMarketPlace
  );
  const handleItemClick = (item) => {
    batch_setSelectedMarketPlaces((prevSelected) => {
      const isAlreadySelected = prevSelected?.some(
        (selected) => selected.id === item._id
      );
      if (isAlreadySelected) {
        return prevSelected.filter((selected) => selected.id !== item._id);
      } else {
        return [...prevSelected, { id: item?._id, name: item?.name }];
      }
    });
  };

  const onSuccessAttachMarketPlace = (res) => {
    if (res.status === 200) {
      console.log(location?.state?.from);
      if (location?.state?.from === "confirm-upload-images") {
        navigate("/order-list");
        return;
      }
      if (
        batch_skipPages.includes("viewGuidelines") &&
        batch_skipPages.includes("addOnService")
      ) {
        navigate(`/upload-images/${params.batchId}`, {
          state: {
            from: "select-marketplace",
          },
        });
      } else if (batch_skipPages.includes("viewGuidelines")) {
        navigate(`/add-on-services/${params.batchId}`);
      } else {
        navigate(`/sequencing/${params.batchId}`);
      }
    } else {
      message.error("Error");
    }
  };
  const onErrorAttachMarketPlace = (err) => {
    message.error(err);
  };
  const { mutate: attachMarketPlace } = useAttachMarketPlaces(
    onSuccessAttachMarketPlace,
    onErrorAttachMarketPlace
  );
  const attachMarketPlaceToBatch = () => {
    const selectedIds = batch_selectedMarketPlaces?.map((value) => value?.id);
    let payload = {
      batchId: params.batchId,
      marketplaces: selectedIds,
    };
    attachMarketPlace(payload);
  };
  const handleWebsite = () => {
    navigate(`/upload-guideline/${params.batchId}`);
  };

  return (
    <>
      <div className="market_place_main_container">
        <div className="market_place_title_wrapper">
          <h4>Where do you want to sell?</h4>
          {isDefault ? (
            <button
              className="addMarketplaceBtn"
              onClick={() => handleWebsite()}
            >
              {" "}
              + Own Website
            </button>
          ) : (
            ""
          )}
        </div>
        <div className="market_place_list_wrapper">
          <div className="cards_main_container">
            {marketPlaceList?.map((item, index) => {
              const isSelected = batch_selectedMarketPlaces?.some(
                (selected) => selected.id === item._id
              );
              return (
                <div className="card_section">
                  <div
                    className={`card_wrapper ${
                      isSelected ? "card_selected" : ""
                    }`}
                    onClick={() => {
                      handleItemClick(item);
                    }}
                  >
                    <div className="logo_wrapper">
                      {item?.image ? (
                        <img
                          src={item?.image?.thumbPath?.url}
                          alt="marketplace"
                        />
                      ) : (
                        <p>{item?.name}</p>
                      )}
                    </div>
                    <input
                      type="checkbox"
                      className="inputCheckbox"
                      checked={isSelected ? true : false}
                    />
                  </div>
                  <p className="name_marketplace">{item?.name}</p>
                </div>
              );
            })}
          </div>
        </div>
        <div className="bottom_panel">
          <Stepper
            activeStep={2}
            nextStep={`/sequencing`}
            backStep={"/upload-images"}
            isSeggregation={false}
          />
          <div className="action_container">
            <button
              className="backBtn"
              onClick={() => navigate(`/upload-images/${params.batchId}`)}
            >
              <img src={BackIcon} alt="backBtn" />
            </button>
            <Button
              text="Next"
              width={"140px"}
              height="50px"
              handleClick={attachMarketPlaceToBatch}
              isDisabled={batch_selectedMarketPlaces.length === 0}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default SelectMarketplace;
